import * as yup from 'yup';

export default yup.object().shape({
  ICHScoreTotal: yup.string().trim(),
  HuntHessSAHTotal: yup.string().trim(),
  MRSTotal: yup.string().trim(),
  NIHSSTotal: yup.string().trim(),
});
